import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["query"];
import React, { forwardRef } from 'react';
import { useAsync } from '../../hooks';
import Typeahead from '../Typeahead';
var AsyncTypeahead = /*#__PURE__*/forwardRef(function (props, ref) {
  var emptyLabel = props.emptyLabel,
    isLoading = props.isLoading,
    _props$promptText = props.promptText,
    promptText = _props$promptText === void 0 ? 'Type to search...' : _props$promptText,
    _props$searchText = props.searchText,
    searchText = _props$searchText === void 0 ? 'Searching...' : _props$searchText;
  var _useAsync = useAsync(props),
    query = _useAsync.query,
    asyncProps = _objectWithoutProperties(_useAsync, _excluded);
  function getEmptyLabel() {
    if (!query.length) {
      return promptText;
    }
    if (isLoading) {
      return searchText;
    }
    return emptyLabel;
  }
  return /*#__PURE__*/React.createElement(Typeahead, _extends({}, props, asyncProps, {
    emptyLabel: getEmptyLabel(),
    ref: ref
  }));
});
export default AsyncTypeahead;